export default __webpack_public_path__ + "static/media/timeup.94f6981f.svg";